export function queryTextContent(
  element: Element,
  querySelector: string,
  fallback = '',
): string {
  return element.querySelector(querySelector)?.textContent?.trim() ?? fallback;
}
